import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ApiState } from '../constants/enums';
import { IClientInsurerReqBody, IClientInsurers, IClientInsurersResponse, ILocalPolicy } from '../types/insurerjurisdiction.type';
import insurerJurisdictionServices from '../services/insurerJurisdictionServices';

export interface InsurerJurisdictionState {
    apiState: {
        getClientInsurer: ApiState;
    };

    clientInsurers: IClientInsurers[];
    localPolicy: ILocalPolicy[];
}
const initialState: InsurerJurisdictionState = {
    apiState: {
        getClientInsurer: ApiState.NOT_STARTED,
    },
    clientInsurers: [],
    localPolicy : [],
};

export const getListOfClientInsurers = createAsyncThunk<
    IClientInsurersResponse,
    { locations: IClientInsurerReqBody[] }
>('insurer-jurisdiction/get-clientinsurers', async ({ locations }) => {
    return insurerJurisdictionServices.getClientInsurers(locations).then((res) => {
        return res;
    });
});

const insurerJurisdictionSlice = createSlice({
    name: 'insurerjurisdiction',
    initialState,
    extraReducers(builder) {
        builder
            .addCase(getListOfClientInsurers.pending, (state) => {
                state.apiState.getClientInsurer = ApiState.PENDING;
            })
            .addCase(getListOfClientInsurers.fulfilled, (state, action: PayloadAction<IClientInsurersResponse>) => {
                state.clientInsurers = action.payload.data.clientInsurers || [];

                state.apiState.getClientInsurer = ApiState.FULFILLED;
            })
            .addCase(getListOfClientInsurers.rejected, (state) => {
                state.apiState.getClientInsurer = ApiState.REJECTED;
            });
    },
    reducers: {},
});

// export const {} = insurerJurisdictionSlice.actions;

export default insurerJurisdictionSlice.reducer;
